import React from 'react'
import { useTheme } from '../../hooks/useTheme'

interface ConfirmDeleteReservaModalProps {
  isOpen: boolean
  reservaId: string
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmDeleteReservaModal: React.FC<ConfirmDeleteReservaModalProps> = ({
  isOpen,
  reservaId,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const { colors } = useTheme()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 bg-red-50">
          <h2 className="text-lg font-semibold text-red-900 flex items-center gap-2">
            🗑️ Confirmar Eliminación
          </h2>
        </div>

        {/* Body */}
        <div className="px-6 py-6 space-y-4">
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-900">
              ⚠️ <strong>Esta acción no se puede deshacer</strong>
            </p>
          </div>

          <div className="space-y-2">
            <p className="text-sm text-gray-700">
              ¿Estás seguro de que deseas eliminar la reserva?
            </p>
            <p className="text-sm font-mono bg-gray-100 text-gray-900 p-2 rounded border border-gray-200">
              {reservaId}
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-xs text-blue-700">
              ℹ️ Esta reserva se eliminará permanentemente de la base de datos. Los pagos asociados no afectarán esta operación.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isLoading ? (
              <>
                <span className="inline-block animate-spin">⏳</span>
                Eliminando...
              </>
            ) : (
              <>
                🗑️ Eliminar Reserva
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDeleteReservaModal
